import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchAdjustmentPeriods = async () => await fetch(
  Config.endpoints.FETCH_ADJUSTMENT_PERIODS
)
  .then(handleErrors({ errorMessage: 'Fetching Adjustment Periods failed' }))
  .then(parseAsJson);

export const fetchCompanyCodes = async period => await fetch(
  Config.endpoints.FETCH_COMPANY_CODES_BEGINNING_BALANCES
    .replace(/:adjustmentPeriod/, period)
)
  .then(handleErrors({ errorMessage: 'Fetching Company Codes failed' }))
  .then(parseAsJson);

export const fetchConnections = async period => await fetch(
  Config.endpoints.FETCH_CONNECTIONS_BEGINNING_BALANCES
    .replace(/:adjustmentPeriod/, period)
)
  .then(handleErrors({ errorMessage: 'Fetching Connections failed' }))
  .then(parseAsJson);

export const fetchBeginningBalancesForCompanyCode = async (period, companyCode) => await fetch(
  Config.endpoints.FETCH_BEGINNING_BALANCES_FOR_COMPANY_CODE
    .replace(/:adjustmentPeriod/, period)
    .replace(/:companyCode/, companyCode)
)
  .then(handleErrors({ errorMessage: 'Fetching Beginning Balances failed' }))
  .then(parseAsJson);

export const fetchCompanyCodesForSelectedConnection = async connectionName => await fetch(
  Config.endpoints.FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES
    .replace(/:connectionName/, connectionName)
)
  .then(handleErrors({ errorMessage: 'Fetching CompanyCodes for Connection failed' }))
  .then(parseAsJson);

export const fetchConnectionDetails = async (connectionName, periodName) => await fetch(
  Config.endpoints.FETCH_ADMIN_CONNECTION
    .replace(/:connName/, connectionName)
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'fetching Connection details failed' }))
  .then(parseAsJson);

export const fetchBeginningBalancesImportStatus = async (adjustmentPeriod, connectionName) => await fetch(
  Config.endpoints.FETCH_BEGINNING_BALANCES_IMPORT_SUMMARY
    .replace(/:adjustmentPeriod/, adjustmentPeriod)
    .replace(/:connectionName/, connectionName)
)
  .then(handleErrors({ errorMessage: 'Fetching Beginning Balances import status failed' }))
  .then(parseAsJson);

export const fetchValidationSummary = async (period, companyCode) => await fetch(
  Config.endpoints.FETCH_BEGINNING_BALANCES_VALIDATION_SUMMARY
    .replace(/:adjustmentPeriod/, period)
    .replace(/:companyCode/, companyCode)
)
  .then(handleErrors({ errorMessage: 'Fetching Validation Summary failed' }))
  .then(parseAsJson);
